/* START GENAI@GHCOPILOT */
/* eslint-disable no-console */

import { saveMeta, saveProofState } from 'communicator/store';
import { getIsFeatureToggleEnabled, getIsVdiDisabled } from 'communicator/store/selectors';
import { generateCodeChallenge, generateCodeVerifier } from './generateCodeVerifier';
import { getInitializationCommand } from './initializationCommand';
import { markEnd, markStart } from './instrumentation';

type LoadVppsParams = {
  vppsOrigin: string;
  sessionId: string;
};

const debuggingEnabled = getIsFeatureToggleEnabled('debuggingEnabled');

async function listenForVpps(vppsOrigin: string) {
  markStart('vpps');
  function listenFromVppsCompletion(e: MessageEvent) {
    if (e.origin === vppsOrigin && typeof e.data === 'string') {
      let result;
      try {
        result = JSON.parse(e.data);
      } catch (_) {
        return;
      }

      if (result.type === 'RESULT' && result.result.command_type === 'INITIALIZATION') {
        const isVdiDisabled = getIsVdiDisabled() || result.result.status !== 'SUCCESS';
        debuggingEnabled && console.log('VPPS - INITIALIZATION', result.result.status);

        saveMeta({
          isVdiDisabled
        });

        if (result.result.status === 'SUCCESS') {
          saveMeta({
            serverState: {
              token: result.result.data.tokens[0].token,
              expiresIn: result.result.data.tokens[0].expires_in
            }
          });
        }
      }

      if (result && result.type === 'EVENT') {
        markEnd('vpps');
        /* START GENAI@GHCOPILOT */

        if (result.event.type === 'DEVICE_DATA_CAPTURE_FAILED') {
          debuggingEnabled && console.log('VPPS - DEVICE_DATA_CAPTURE_FAILED');

          saveMeta({
            isVdiDisabled: true
          });
        } else if (result.event.type === 'DEVICE_DATA_CAPTURED') {
          debuggingEnabled && console.log('VPPS - DEVICE_DATA_CAPTURED');
        }
        /* END GENAI@GHCOPILOT */

        window.removeEventListener('message', listenFromVppsCompletion);
      }
    }
  }

  window.addEventListener('message', listenFromVppsCompletion);
}

async function createIframeVpps(initializationCommand: string, vppsOrigin: string) {
  const iframeId = 'vcop-src-vpps-frame';
  const vppsFrameCheck = document.getElementById(iframeId);

  if (vppsFrameCheck) {
    vppsFrameCheck.parentNode?.removeChild(vppsFrameCheck);
  }

  const vppsIframe = document.createElement('iframe');
  vppsIframe.id = iframeId;
  vppsIframe.src = `${vppsOrigin}/oauth2/authorization/request/hub#msg=${initializationCommand}`;
  /* START GENAI@GHCOPILOT */
  vppsIframe.sandbox.add('allow-same-origin');
  vppsIframe.sandbox.add('allow-scripts');
  vppsIframe.sandbox.add('allow-forms');
  /* END GENAI@GHCOPILOT */
  vppsIframe.style.position = 'absolute';
  vppsIframe.style.height = '0';
  vppsIframe.style.width = '0';
  vppsIframe.style.border = 'none';
  markStart('vpps-load');
  vppsIframe.onload = () => {
    markEnd('vpps-load');
  };

  document.body.appendChild(vppsIframe);
}

export async function loadVpps({ vppsOrigin, sessionId }: LoadVppsParams) {
  saveMeta({ isVdiDisabled: false });
  const codeVerifier = generateCodeVerifier();
  const codeChallenge = await generateCodeChallenge(codeVerifier);
  saveProofState({ codeVerifier, codeChallenge });
  const initializationCommand = getInitializationCommand(codeChallenge, sessionId);
  markStart('vpps-DomContentLoaded');
  listenForVpps(vppsOrigin);
  await createIframeVpps(initializationCommand, vppsOrigin);
  markEnd('vpps-DomContentLoaded');
}
/* END GENAI@GHCOPILOT */
